











































import { gsap } from "gsap";
import TheHeaderNaviOnGeneral from "@/common/components/organisms/header/general/TheHeaderNaviOnGeneral.vue";
import TheHeaderNaviOnAdmin from "@/common/components/organisms/header/admin/TheHeaderNaviOnAdmin.vue";
import HeaderGroupNavi from "@/common/components/organisms/header/admin/HeaderGroupNavi.vue";

import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHamburger from "@/common/components/icons/IconHamburger.vue";
import TheHeaderNaviProfilePanel from "@/common/components/organisms/header/TheHeaderNaviProfilePanel.vue";
import HeaderNaviSwitchButtonForSpLayout from "@/common/components/organisms/header/HeaderNaviSwitchButtonForSpLayout.vue";

import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import modalState from "@/common/store/modules/modalState";

import globals from "@/general/store/modules/globals";
import adminGlobals from "@/admin/store/modules/globals";
import LocalStorage from "@/general/utils/storage";

@Component({
  name: "TheHeaderNaviForSpLayout",
  components: {
    TheHeaderNaviOnGeneral,
    TheHeaderNaviOnAdmin,
    HeaderGroupNavi,
    IconBase,
    IconHamburger,
    TheHeaderNaviProfilePanel,
    HeaderNaviSwitchButtonForSpLayout
  }
})
export default class TheHeaderNaviForSpLayout extends Vue {
  @Prop({ type: Number, required: false, default: 0 })
  whatsNewUnreadCount!: number;
  @Prop({ type: Number, required: false, default: 0 })
  thanksPointUnreadCount!: number;
  @Prop({ type: Number, required: true })
  point!: number;
  @Prop({ type: String, required: true, default: "0" })
  isUserAdmin!: string;

  shown = false;
  switchButton: Record<string, any> = {};

  get currentComponent() {
    const pageType = this.headerInfo.pageType;
    const componentInitials = pageType.charAt(0).toUpperCase();
    const componentSuffix = `${componentInitials}${pageType.slice(1)}`;
    return `TheHeaderNaviOn${componentSuffix}`;
  }

  get currentProperties() {
    return {
      whatsNewUnreadCount: this.whatsNewUnreadCount,
      thanksPointUnreadCount: this.thanksPointUnreadCount,
      point: this.point
    };
  }

  get headerInfo() {
    return commons.headerInfo;
  }

  @Watch("true")
  onShownchanged() {
    modalState.switchHtmlElementScrollFixedStyle(this.shown);
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  get isSp() {
    if (this.isAdminSite) {
      return adminGlobals.isLargeBreakpointWidthOfSp;
    }
    return globals.isLargeBreakpointWidthOfSp;
  }

  get isAdminSite() {
    return false;
  }

  @Watch("closeModalState")
  oncloseModalStatechange() {
    this.shown = false;
    this.animationShownDrawer(this.shown);
  }

  mounted() {
    modalState.switchHtmlElementScrollFixedStyle(this.shown);
    this.initDrawerStyle();
    this.initSwitchButtonObject();
  }

  switchShownState() {
    // if (shown === false) this.shown = true;
    this.shown = !this.shown;
    this.animationShownDrawer(this.shown);
  }

  initDrawerStyle() {
    const refs = this.$refs;
    const { drawer, drawerContainer } = refs;

    gsap.set(drawer, {
      x: "-100%"
    });

    gsap.set(drawerContainer, {
      autoAlpha: 0
    });
  }

  animationShownDrawer(shown: boolean) {
    const refs = this.$refs;
    const { drawerContainer } = refs;
    const { drawer } = refs;
    const openTl = gsap.timeline();
    const closeTl = gsap.timeline();
    const speed = 0.2;
    const delay = 0.08;

    const animationObj = {
      true() {
        openTl
          .to(drawerContainer, speed / 2, {
            delay: delay,
            autoAlpha: 1
          })
          .to(drawer, speed, {
            x: "0%"
          });
      },

      false() {
        closeTl
          .to(drawer, speed, {
            x: "-100%"
          })
          .to(drawerContainer, speed / 2, {
            autoAlpha: 0,
            onComplete() {
              this.shown = false;
            }
          });
      }
    };

    animationObj["true"]();
    // animationObj[this.shown.toString()]();
  }

  initSwitchButtonObject() {
    let pageType = "general";
    if (this.isAdminSite) {
      pageType = "admin";
    } else {
      pageType = "general";
    }
    this.switchButton = this.headerInfo.switch[pageType];
  }

  emitClickEvent() {
    this.$emit("click-change-modal-state");
    modalState.setCloseModalState(!modalState.closeModalState);
  }
}
